/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React,{useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import VirtualPaymentInstructions from './VirtualPaymentInstructions'

export default function Success({orderSuccess,orderFlow,OrderData,adorCaashConfig,Privilages, cashDiscountMessage}) {
    const [virtualInstructions, setvirtualInstructions] = useState(false)
    const handlePrivilage=()=>{
        let res='';
        let type=''
        Privilages.map((val)=>{
            if( val==='cash_discount'){
                res=true
                type=val

            }
        })
        return type
    }
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01]
            }} className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-3 mx-auto pointer-events-none" style={{margin: 'auto'}}>
            {!virtualInstructions?<div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current md:px-[50px] sm:px-5 px-3 sm:pt-[32px] pt-4 pb-5">
                <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                        Order Placed Successfully!
                    </h5>
                </div>
                <div className="modal-body sm:pt-6 pt-5">
                    <img src="/images/success.gif" alt="icon" className="mx-auto"  style={{maxWidth:'80px',maxHeight:'80px'}}/>
                    <>
                        {orderFlow.order_type==='Trade EUB Order'?
                            <>
                                <p className="sm:pt-4 pt-3 text-center text-xs6 font-normal text-[#090406]">Thank you, your order is under review.</p>
                                <p className="text-center text-xs6 font-normal text-[#090406]">
                                    Once accepted/Rejected you will be notified in your email. You can track your order in the My Orders section post-order acceptance
                                </p>
                            </>
                            :
                            <>{handlePrivilage()===''?<div className="border border-[#BBDBAA] sm:px-[18px] sm:pt-5 sm:pb-6 p-3.5 bg-[#EBFFE0] sm:mt-5 mt-4 rounded-lg">
                                <p className="pb-3 text-xs2 font-normal text-[#090406]">To avail additional 2% Cashback, Pay Order Amount 100%  <b>as per the Policy</b> from the date of Invoice.</p>
                                <p className="text-xs2 font-normal text-[#090406]"> On getting remitted the payment, the Cashback amount will get credited to Falcon Wallet for you to utilise for subsequent order(s).</p>
                            </div>:<div className="border border-[#BBDBAA] sm:px-[18px] sm:pt-5 sm:pb-6 p-3.5 bg-[#EBFFE0] sm:mt-5 mt-4 rounded-lg">
                                {/* <p className="pb-3 text-xs2 font-normal text-[#090406]">Cash Discount: Please pay 100% of the invoice amount <b>as per the Cash Discount Policy </b>(mentioned under Ador Cash in T&C Policy) to avoid reversal of availed CD.</p> */}
                                <p className="pb-3 text-xs2 font-normal text-[#090406]">{cashDiscountMessage}</p>

                            </div>}</>
                            
                        }
                    </>
                    {orderSuccess.map((item,i)=>(
                        <p key={i}className="sm:pt-6 pt-4 sm:text-xl text-lg font-semibold leading-normal text-[#090406] text-center">
                            <span className='flex justify-center'>Order Number: {item.split('-')[0]}</span></p>
                    ))}
                    {(orderFlow.order_type==='Trade Order' || (OrderData && OrderData.order && Number(OrderData.order?.work_flow_status) > 1)) &&<div className="flex justify-center sm:mt-[26px] mt-5 sm:mb-6 mb-5">
                        <button
                            onClick={()=>setvirtualInstructions(true)}
                            type="button" className="flex items-center text-sm font-semibold text-[#555259]" data-bs-toggle="modal" data-bs-target="#virtualPayment">
                            Virtual Payment Instructions
                            <span className="ml-1">
                                <img src="/images/Path-right.svg" alt="icon"/>
                            </span>
                        </button>
                    </div>}
                    <div className="pt-3.5 w-full">
                        <Link to={`/orders`} className="w-full flex justify-center">
                            <button type="button" className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                Go to Order
                            </button>
                        </Link>
                    </div>
                </div>
            </div>:<VirtualPaymentInstructions setvirtualInstructions={setvirtualInstructions} />}
        </motion.div>
    )
}
